import { Option } from 'types';
import { translate } from '@utils';
import { ContactHandlerKeys, SubmissionTypes } from '@enums';

export const submissionsTypes: Option<SubmissionTypes>[] = [
  {
    label: translate('template_all'),
    value: SubmissionTypes.All,
  },
  {
    label: translate('template_own'),
    value: SubmissionTypes.Own,
  },
  {
    label: translate('template_common'),
    value: SubmissionTypes.Common,
  },
  {
    label: translate('template_private'),
    value: SubmissionTypes.Private,
  },
];

export const contactTypesOptions: Option<string | null>[] = [
  {
    value: '',
    label: 'None',
  },
  {
    value: ContactHandlerKeys.SKYPE,
    label: 'Skype',
  },
  {
    value: ContactHandlerKeys.TELEGRAM,
    label: 'Telegram',
  },
  {
    value: ContactHandlerKeys.EMAIL,
    label: 'Email',
  },
];
